import * as types from '@/store/mutation-types'

export default function({ store: { commit }, route }) {
  commit(types.SET_PREVIEW_MODE, !!route.query.previewId)
}
